import cityProvince from "@/api/corporate/city-province";
import { baseState, baseMutations } from "@/store/mixins";

export const state = {
    ...baseState
};

export const getters = {};

export const mutations = {
    ...baseMutations
};

export const actions = {
    fetch(context, attributes = {}) {
        const params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: context.state.search
                }
            },
            attributes
        );
        return cityProvince.get({ params }).then(response => {
            context.commit("RECEIVE_RESOURCES", response);
            return Promise.resolve(response);
        });
    },

    store(context, data) {
        return cityProvince.store(data);
    },

    update(context, { id, data }) {
        return cityProvince.update(id, data);
    },

    destroy(context, id) {
        return cityProvince.destroy(id);
    }
};
